import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { EasmScanConfigurationAssetGridDataProviderFactory } from '../factory/EasmScanConfigurationAssetGridDataProviderFactory';
import { EasmScanConfigurationAssetGridBaseDataProvider } from '../dataProvider/EasmScanConfigurationAssetGridBaseDataProvider';
import { EASMScanConfigurationAssetGridViewData } from '../types';

export class EasmScanConfigurationAssetGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: EasmScanConfigurationAssetGridDataProviderFactory;
  public dataProvider: EasmScanConfigurationAssetGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new EasmScanConfigurationAssetGridDataProviderFactory(),
    });
  }

  public async getDataForView(): Promise<EASMScanConfigurationAssetGridViewData> {
    return await this.dataProvider.getDataForView();
  }
}
